import React from "react";
import { Space } from "antd";
import PageHeader from "../../../components/PageHeader";
import RunLauncher from "./RunLauncher";
import RunsList from "./RunsList";

const RevisionODs: React.FC = () => (
  <Space direction="vertical" style={{ width: "100%" }} size="middle">
    <PageHeader title="Revisión de ODs" />
    <RunLauncher />
    <RunsList />
  </Space>
);

export default RevisionODs;
